/**
 * Click-outside handler utility.
 * Binds a document-level click listener that calls `onClose` when a click
 * occurs outside the given element. Returns an unbind function.
 *
 * @param {HTMLElement} element - The element to watch
 * @param {Function} onClose - Callback invoked on outside click
 * @returns {Function} Call this to remove the listener
 */
export function bindClickOutside(element, onClose) {
  function handler(event) {
    if (!element.contains(event.target)) {
      onClose(event)
    }
  }

  document.addEventListener("click", handler)

  return function unbind() {
    document.removeEventListener("click", handler)
  }
}
